import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ConfirmationDialog } from '@app/shared-modules/confirmation-dialog/dialogs';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ConfirmationDialog],
    imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
    exports: [ConfirmationDialog],
})
export class ConfirmationDialogModule {}
